import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Col, Form, Button } from 'antd'

import PasswordField from 'components/Password'
import NumberField from 'components/NumberFiled'
import CustomNotifocation from 'components/CustomNotification'
import { getTokenData } from 'store/actions/login'

import { removeNotificationAsan } from 'store/actions/login'

import { BUTTONS } from '../../../../../../../constants/constants'
import { useActions } from '../../../../../../hooks/useActions'
import { useHistory } from 'react-router-dom'
import { SpinnerIco } from "../../../../../../../modules/CustomIcons"
import { useTranslation } from 'react-i18next'


const AsanForm: React.FC<any> = ({ inProgressAsan, tabValue }) => {
  const {t} = useTranslation();

  let formData = [
    {
      id: 1,
      name: 'phoneNumber',
      size: 'large',
      placeholder: t("login.mobileNumber"),
      type: 'phoneNumber',
    },
    {
      id: 2,
      name: 'userId',
      size: 'large',
      placeholder: t("login.userID"),
      type: 'password',
    },
  ]
  
  const { getTokenData, removeNotificationAsan } = useActions()
  const [phoneNumber, setPhoneNumber] = useState('')
  const [enteredValue, setEnteredValue] = useState('')
  const [notify, setNotify] = useState(false)
  const [asanAutoComplete, setAsanAutoComplete1] = useState(false)

  const [form] = Form.useForm()
  const history = useHistory()

  const onFinishAsan = (args: any) => {
    if (!args.userId || !args.phoneNumber) {
      setNotify(true)
    } else {
      // let phoneData = args.phoneNumber !== null ? '994' + args.phoneNumber.split('-').join('').replace(/[- )(]/g, '') : ''
      let phoneData = phoneNumber !== null || phoneNumber !=="" ? '994' + phoneNumber.split('-').join('').replace(/[- )(]/g, '') : ''
      let postData = {
        phoneNumber: phoneData,
        userId: args.userId,
        channel: 'INT',
      }
      getTokenData(postData, history)
    }
  }
  const handleInputChange = (e: any) => {
    if (asanAutoComplete) {
      setPhoneNumber(e.target.value)
    }
    setAsanAutoComplete1(true)
  }

  useEffect(() => {
    setAsanAutoComplete1(false)
  }, [tabValue])


  const resetEnteredValue = () => {
    if (enteredValue && enteredValue.length < 9) {
      setPhoneNumber('')
    }
  }
  const closeNotification = () => {
    removeNotificationAsan()
    setNotify(false)
  }
  const [passwordValue, setPasswordValue] = useState('')

  function handlePasswordChange(e: any) {
    setPasswordValue(e.target.value)
  }
  const stopForm = (e: any) => {
    e.stopPropagation()
    e.preventDefault()
    e.nativeEvent.stopImmediatePropagation();
  }

  const onClickNumberFormatFunc = () => {
    setAsanAutoComplete1(true)
  }

  return (
    <>
      {notify && <CustomNotifocation message= {t("login.fillField")} />}
      {/* {errorMessage && notifyData && <CustomNotifocation message={errorMessage[0].MESSAGE}/> } */}
      <Form
        form={form}
        name={'asan'}
        onSubmit={stopForm}
        onBlur={closeNotification}
        onFinish={onFinishAsan}
        autoComplete="off"
      >
        <div className="login-form-inputs">
          {formData &&
            formData.map((formItem) => {
              return (
                <div key={formItem.id}>
                  {formItem.type == 'phoneNumber' && (

                    <NumberField
                      key={formItem.id}
                      label={formItem.placeholder}
                      name={formItem.name}
                      format='(##) ###-##-##'
                      mask={'_'}
                      placeholder='(00) 000-00-00'
                      handleInputChange={handleInputChange}
                      onBlur={resetEnteredValue}
                      value={phoneNumber}
                      form={form}
                      onClickNumberFormatFunc = {onClickNumberFormatFunc}
                      onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values
                        setEnteredValue(values.value)

                        if(asanAutoComplete){
                          setPhoneNumber(values.value)
                        }
                        setAsanAutoComplete1(true)
                      }}
                    ></NumberField>
                  )}

                  {formItem.type == 'password' && (
                    <PasswordField
                      key={formItem.id}
                      label={formItem.placeholder}
                      name={formItem.name}
                      type={formItem.type}
                      form={form}
                      passwordValue={passwordValue}
                      handlePasswordChange={handlePasswordChange}
                    ></PasswordField>
                  )}
                </div>
              )
            })}
        </div>
        <div className="login-form__buttons">
          <Col md={{ span: 24 }}>
            <Button size={'large'}
              icon={inProgressAsan && <SpinnerIco />}
              disabled={inProgressAsan}
              className="blue enter" htmlType="submit" id='asanBtn'>
              {t(BUTTONS.ENTER)}
            </Button>
          </Col>
        </div>
      </Form>
    </>
  )
}
const mapDispatchToProps = { getTokenData, removeNotificationAsan }

const mapStateToProps = (state: any) => ({
  notifyData: state.token.notify,
  errorMessage: state.token.error ? state.token.error.messages : '',
  inProgressAsan: state.token.inProgressAsan,
  tabValue: state.login ? state.login.tabValue : '1',
})
export default connect(mapStateToProps, mapDispatchToProps)(AsanForm)
